import styles from "./ReadOnlyChoiceMain.module.scss";

function ReadOnlyChoiceMain({ children }) {
  return <div className={styles["main"]}>{children}</div>;
}

export default ReadOnlyChoiceMain;
